import React, { Component } from "react";
import './ScrollToTopButton.css';

interface Props {
  thresholdOffsetToActivate?: number
}

interface State {
  thresholdOffsetToActivate: number
  isVisible: boolean
}

export default class ScrollToTopButton extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      thresholdOffsetToActivate: props.thresholdOffsetToActivate === undefined ? 300 : props.thresholdOffsetToActivate,
      isVisible: false
    };
  }

  componentDidMount() {
    const scrollComponent = this;
    document.addEventListener("scroll", function (e) {
      scrollComponent.toggleVisibility();
    });
  }

  toggleVisibility() {
    if (window.pageYOffset > this.state.thresholdOffsetToActivate) {
      this.setState({
        isVisible: true
      });
    } else {
      this.setState({
        isVisible: false
      });
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  renderButtonContent = () => {
    return (
      <div
        className="scroll-to-top-inner fade-in-content"
        onClick={() => this.scrollToTop()}
      >
      </div>
    );
  }

  render() {
    return (
      <div className="scroll-to-top">
        {this.state.isVisible ? this.renderButtonContent() : null}
      </div>
    );
  }

}
